<template>
  <div>
    <v-btn
      :disabled="disabled"
      :loading="loading"
      :hidden="hidden"
      :color="btnSettings.color"
      :outline="btnSettings.outline"
      :round="btnSettings.round"
      :small="btnSettings.small"
      :dark="btnSettings.dark"
      :class="btnClass"
      @click="$emit('handle-button-click')"
    >
      {{ btnText }}
      <template v-slot:loader>
        <span class="spinner-loader">
          <v-icon dark>cached</v-icon>
        </span>
        <span class="spinner-message">
          {{ loadingMessage }}
        </span>
      </template>
    </v-btn>
  </div>
</template>

<script>
import colors from '../../scss/_colors.scss'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    btnText: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      required: true
    },
    btnSettings: {
      type: Object,
      default: () => ({
        outline: false,
        color: colors.hwayzBrandGold,
        round: false,
        small: false
      })
    },
    loadingMessage: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/scss/_animations.scss"

.auth-button
  width: 100%
  margin-top: 3rem
  color: $hwyzHeaderClient !important

.feedback-modal-button
  width: 20rem
  margin: 2rem 3rem 0
  float: right

.btn-load-more
  width: calc(100% - 16px)
  margin: 2rem 8px 4rem 8px !important
  color: $hwayzWhite !important
  background-color: $hwayzBlack !important

.btn-map
  position: absolute !important
  z-index: 2
  top: 3rem
  right: 5rem
  font-size: 1.2rem
  width: 25rem
  color: $hwayzWhite !important
  background-color: $hwayzBlack !important

.requested-home-button
  color: $hwayzDarkerGray !important

.spinner-loader
  animation: loader 1s infinite
  display: flex

.spinner-message
  font-size: 1rem
  color: $hwayzWhite
  text-transform: capitalize
  padding-left: 1rem

.disabled
  @extend %disabled-state
  opacity: 0.2
</style>
